import { stringify } from "querystring";
import ExerciseController from "../exercise/exercise.controller";

export default class mainController {
    constructor($scope, $location, exerciseService, eventService, globalConstants, authenticationService) {
        this.$scope = $scope;
        this.$location = $location;
        this.exerciseService = exerciseService;
        this.globalConstants = globalConstants;

        $scope.selectedEvent = null;

        if(!authenticationService.isSuperUser()) {
            exerciseService.getAll().then((resp) => {
                this.exercises = this.filterExercises(resp.data);
                eventService.getAll().then(resp => {
                    this.events = resp.data;
                }, resp => {
                    console.log("ERROR: Can't retrieve events");
                });
            });
        }

        if(authenticationService.isSuperUser()){
            this.$location.path("/subscriptions");
        }

        this.userType = authenticationService.getUserType();
    }

    downloadExercise(id){
        window.location.href = this.globalConstants.ApiBaseUrl + "/api/sessionexport/ExportSessionToHtmlString?exerciseId=" + id;
    }
    onChangeEvent(event) {
        if(event == null)
        {
            this.exerciseService.getAll().then((resp) => {
                this.exercises = this.filterExercises(resp.data);
                //this.setExerciseTimes();
            });
        }
        else {
            this.exerciseService.getByEventId({ eventId: event.id }).then(resp => {
                this.exercises = this.filterExercises(resp.data);
                //this.setExerciseTimes();
            });
        }
    }

    filterExercises(exercises){return exercises.filter(x=>x.hidden==false);}
}


// WEBPACK FOOTER //
// ./src/js/components/main/main.controller.js